<template>
    <div class="container search">
        <div class="row">
            <div class="col-md-12">
                <h2>
                    Claim - {{claim_id}}
                </h2>
                <a href="/claims" class="link">Back to claims list</a>
            </div>
            <div class="col-md-12 view-claim-details" v-if="claim">
                <template v-if="claim.status">
                    <strong>Status</strong>
                    <span v-if="claim.status == 1" class="badge badge-warning">Pending</span>
                    <span v-else-if="claim.status == 2" class="badge badge-primary">In Process</span>
                    <span v-else-if="claim.status == 3" class="badge badge-success">Processed</span>
                    <br />
                </template>
                <template v-if="claim.user">
                    <strong>User</strong>
                    <a :href="$laravelRoute('users.show', claim.user_id)">
                        {{claim.user.name}}
                    </a> <br />
                </template>
                <template v-if="claim.user && claim.user.company">
                    <strong>Company </strong>
                    <a :href="$laravelRoute('companies.show', claim.user.company.id)">
                        {{claim.user.company.name}}
                    </a> <br />
                </template>
                <template v-if="claim.vehicle">
                    <strong>Vehicle</strong>
                    <a :href="$laravelRoute('vehicle-stock.show', claim.vehicle.id)">
                        {{ claim.vehicle.year }}
                        {{ claim.vehicle.make }}
                        {{ claim.vehicle.model }}
                    </a> <br />
                </template>

                <strong>Claim Number</strong>
                <a :href="$laravelRoute('claims.show', claim_id)">
                    {{claim_id}}
                </a>
                <br />
                <strong>Reason</strong> {{claim.reason}} <br />
                <strong>Description</strong> {{claim.description}} <br />
                <strong>Repair Cost</strong> {{claim.repair_cost}} <br />
                <strong>Files</strong>
                <ul v-if="claim.files && claim.files.length">
                    <li v-for="file in claim.files">
                        <a :href="file.url">{{file.name}}</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios";

export default {
    props: [
        'claim_id',
    ],
    async created() {
        await this.getClaim()
    },
    data() {
        return {
            claim: null
        }
    },
    methods: {
        async getClaim(){
            const res = await axios.get(this.$laravelRoute('claims.show', this.claim_id));
            if (res && res.data && res.data.claim) {
                this.claim = res.data.claim;
            }
        },
    }
}
</script>



// WEBPACK FOOTER //
// resources/js/components/Claims/ShowClaim.vue